import { gql } from '@/__generated__';

const UPDATE_DGA_TICKET = gql(`#graphql
  mutation UpdateDgaTicket(
    $deviceId: ID!
    $ticketId: String!
    $ticketTimestamp: Date!
    $status: String!
  ) {
    updateDgaTicket(
      deviceId: $deviceId
      ticketId: $ticketId
      ticketTimestamp: $ticketTimestamp
      status: $status
    ) {
      id
      dga {
        id
        ticket {
          id
          timestamp
        }
      }
    }
  }
`);

export default UPDATE_DGA_TICKET;
